export const shadow = [
  '0 1px 3px #0000001f, 0 1px 2px #0000003d',
  '0 3px 6px #00000029, 0 3px 6px #0000003b',
  '0 10px 20px #00000033, 0 6px 6px #0000003b',
  '0 14px 28px #00000040, 0 10px 10px #00000038',
  '0 19px 38px #0000004d, 0 15px 12px #00000038',
]
